export interface GeofenceResponse {
  id: string;
  name: string;
  type: 'circle' | 'polygon';
  color: string;
  address: string;
  assignedUserId?: string;
  assignedUserName?: string;
  isActive: boolean;
  createdAt: string;
  centerLatitude?: number;
  centerLongitude?: number;
  radiusMeters?: number;
  polygonVertices?: Array<{
    latitude: number;
    longitude: number;
    order: number;
  }>;

  patrollingEnabled: boolean;
  patrollingUsers?: Array<{
    userId: string;
    userName: string;
  }>;
  // breachingEnabled: boolean;
  // breachingExceptionsEnabled: boolean;
  // breachingExceptions?: Array<{
  //   userId: string;
  //   userName: string;
  // }>;
}

export interface PatrolSession {
  id: string;
  userId: string;
  userName: string;
  geofenceId: string;
  geofenceName: string;
  orchestrationId: string;
  startedAt: Date;
  endedAt?: Date;
  isActive: boolean;
  totalChecks: number;
  violationCount: number;
  duration?: string;
  startLatitude?: number;
  startLongitude?: number;
  endLatitude?: number;
  endLongitude?: number;
  sessionData?: string;
}

export interface PatrolViolation {
  id: string;
  geofenceId: string;
  violationType: string;
  latitude?: number;
  longitude?: number;
  distanceOutside?: number;
  timestamp: Date;
  isResolved: boolean;
  resolvedAt?: Date;
  userRole?: string;
}

export interface UserPatrolData {
  userId: string;
  hasPatrollingAssignment: boolean;
  assignedPatrollingGeofences: GeofenceResponse[];
  totalAssignedGeofences: number;
  statistics: {
    totalSessions: number;
    activeSessions: number;
    completedSessions: number;
    totalPatrolTimeMinutes: number;
    totalViolations: number;
    unresolvedViolations: number;
    totalChecks: number;
    totalDistanceOutsideMeters: number;
    violationRate: number;
    averageViolationsPerSession: number;
  };
  sessions: PatrolSession[];
  violations: PatrolViolation[];
}

export interface GuardPatrolState {
  userPatrolData: UserPatrolData | null;
  patrolSessions: PatrolSession[];
  userPatrolSessions: PatrolSession[];
  patrolViolations: PatrolViolation[];
  currentPatrolSession: PatrolSession | null;
  assignedGeofences: GeofenceResponse[];
  loading: boolean;
  error: string | null;
  hasPatrollingAssignment: boolean;
  statistics: {
    totalSessions: number;
    activeSessions: number;
    completedSessions: number;
    totalViolations: number;
    unresolvedViolations: number;
    violationRate: number;
  } | null;
}

export const initialGuardPatrolState: GuardPatrolState = {
  userPatrolData: null,
  patrolSessions: [],
  userPatrolSessions: [],
  patrolViolations: [],
  currentPatrolSession: null,
  assignedGeofences: [],
  loading: false,
  error: null,
  hasPatrollingAssignment: false,
  statistics: null,
};
